import { FormHandles } from '@unform/core';
import React, { useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';

import { AuthLayout } from '../../../../components/AuthLayout';
import { AuthFormHeader } from '../../../../components/AuthFormHeader';
import { Button } from '../../../../components/Button';
import { Icon } from '../../../../components/Icon';
import { InputToken } from '../../../../components/InputToken';
import { colors } from '../../../../styles/tokens';
import { useToast } from '../../../../hooks/toast';
import { api } from '../../../../services/api';

import { BackLink, Form } from './styles';

interface formProps {
  token: string;
}

const SignUpVerify: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const navigate = useNavigate();
  const { addToast } = useToast();

  const handleSubmit = useCallback(
    async (data: formProps) => {
      try {
        formRef.current?.setErrors({});

        const schema = yup.object().shape({
          token: yup.string().required('Campo obrigatório'),
        });

        await schema.validate(data, { abortEarly: false });

        const code = data.token.toUpperCase();

        const response = await api.get('/users/verify-token', {
          headers: {
            code,
          },
        });

        navigate('/sign-up/identity', {
          state: {
            fullname: response.data.fullname,
            nickname: response.data.nickname,
            email: response.data.email,
            gym_id: response.data.gym_id,
            code,
          },
        });
      } catch (err) {
        if (err instanceof yup.ValidationError) {
          formRef.current?.setErrors({ token: 'Required' });

          return;
        }
        addToast({
          type: 'error',
          title: 'Token inválido.',
          description:
            'Tente novamente ou entre em contato com sua academia ou personal.',
        });
      }
    },
    [addToast, navigate],
  );

  return (
    <AuthLayout
      eyebrow="Fluxo de cadastro"
      title={
        <>
          INSIRA O <span>CÓDIGO DE ACESSO</span>
        </>
      }
      subtitle="Sua academia ou personal trainer enviou um código de cadastro para o seu email. Insira-o para continuar."
    >
      <AuthFormHeader
        badge="Passo 1 de 2 · Verificação"
        title="Continuar cadastro"
        subtitle="Insira abaixo o código recebido no email para confirmação. Verifique também na caixa de spam."
      />

      <Form ref={formRef} onSubmit={handleSubmit}>
        <InputToken name="token" />

        <Button name="submit" value="Continuar" />
      </Form>

      <BackLink type="button" onClick={() => navigate('/sign-in')}>
        <Icon name="arrow_back" size={18} color={colors.onSurfaceVariant} />
        Voltar ao login
      </BackLink>
    </AuthLayout>
  );
};

export { SignUpVerify };
